import { Map } from 'immutable';

import * as PaymentsConstants from '../constants';
import * as D from '../deps';

const INITIAL_STATE = Map({
  [PaymentsConstants.ReducerKeys.SELECTED_TIER]: '',
  [PaymentsConstants.ReducerKeys.SELECTED_DISCOUNT_TYPE]: PaymentsConstants.discountTypes.NONE,
});

export default D.createReducer(INITIAL_STATE, {
  [PaymentsConstants.Actions.SELECT_OFFER]: onSelectOffer,
  [PaymentsConstants.Actions.CLEAR_SELECTED_OFFER]: onClearSelectedOffer,
});

function onSelectOffer(state, { payload: { tier, discountType } }) {
  return state.merge({
    [PaymentsConstants.ReducerKeys.SELECTED_TIER]: tier,
    [PaymentsConstants.ReducerKeys.SELECTED_DISCOUNT_TYPE]:
      discountType || PaymentsConstants.discountTypes.NONE,
  });
}

function onClearSelectedOffer(state) {
  return state.merge({
    [PaymentsConstants.ReducerKeys.SELECTED_TIER]: '',
    [PaymentsConstants.ReducerKeys.SELECTED_DISCOUNT_TYPE]: PaymentsConstants.discountTypes.NONE,
  });
}
